import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useNotifications } from './notification.context'
import { useAuthStore } from '../auth.context/auth.context'
import HubSwitchModal from './components/hub-switch-modal'

interface Hub {
  uuid: string
  name: string
  [key: string]: any
}

export const NotificationHandler = () => {
  const navigate = useNavigate()
  const { audio } = useNotifications()
  const { selectedHub, user, setSelectedHub } = useAuthStore()

  const [pendingNavigation, setPendingNavigation] = useState<{
    path: string
    hubUuid: string | null
    hubName: string
  } | null>(null)

  const findHubByUuid = (uuid: string): Hub | null => {
    if (!user || !user.hubs || !user.hubs.length) return null

    const hub = user.hubs.find((hub) => hub.uuid === uuid) || null
    return hub
  }

  const switchToHub = (hubUuid: string) => {
    const hub = findHubByUuid(hubUuid)
    if (hub && setSelectedHub && typeof setSelectedHub === 'function') {
      setSelectedHub(hubUuid)
      return true
    }

    return false
  }

  useEffect(() => {
    const handleServiceWorkerMessage = (event: MessageEvent) => {
      const { data } = event

      if (data && data.type === 'NAVIGATE_TO') {
        const { url, hubUuid } = data

        const originUrl = window.location.origin
        let path = url

        if (url.startsWith(originUrl)) {
          path = url.substring(originUrl.length)
        }

        if (path && path.startsWith('/')) {
          if (hubUuid && selectedHub && hubUuid !== selectedHub.uuid) {
            const targetHub = findHubByUuid(hubUuid)

            if (targetHub) {
              setPendingNavigation({
                path,
                hubUuid,
                hubName: targetHub.trading_name || targetHub.name,
              })
              return
            }
          }

          audio?.pause()
          navigate(path)
        } else {
          console.error('Caminho de navegação inválido:', path)
        }
      }
    }

    navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage)

    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'REACT_NAVIGATION_READY',
      })
    } else {
      console.warn('Service Worker não está controlando a página ainda')
    }

    return () => {
      audio?.pause()
      navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage)
    }
  }, [navigate, audio, selectedHub, user])

  const handleConfirmHubSwitch = () => {
    if (pendingNavigation && pendingNavigation.hubUuid) {
      const hubUuid = pendingNavigation.hubUuid
      const path = pendingNavigation.path

      const switched = switchToHub(hubUuid)

      if (switched) {
        navigate(path)
      } else {
        console.error('Falha ao trocar de hub')
      }
      setPendingNavigation(null)
    } else {
      console.error('Navegação pendente não definida ou sem hubUuid')
    }
  }

  const handleCancelHubSwitch = () => {
    setPendingNavigation(null)
  }

  return (
    <>
      {pendingNavigation && selectedHub && (
        <HubSwitchModal
          open={true}
          targetHubName={pendingNavigation.hubName}
          currentHubName={selectedHub.name}
          onConfirm={handleConfirmHubSwitch}
          onCancel={handleCancelHubSwitch}
        />
      )}
    </>
  )
}

export default NotificationHandler
